<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="User Premium Management">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex items-center">
            <div class="mr-2">
              <el-input placeholder="search name or email" v-model="filter.q" @change="searchUser"></el-input>
            </div>
            <div class="mr-2 flex items-center">
              <span class="text-xs font-bold mr-2">Duration:</span>
              <el-select v-model="grantDuration" placeholder="Select Duration">
                <el-option v-for="d in durationOptions" :key="d.value" :value="d.value" :label="d.label"></el-option>
              </el-select>
            </div>
            <Button @clicked="searchUser" label="Apply"/>
            <button class="p-2"><font-awesome-icon :icon="['fas', 'sync']" @click="reset" /></button>
          </div>
        </div>

        <data-tables-server ref="tableUser" :data="data" :total="total" :pagination-props="{ background: true, pageSizes: [20,50,100,300] }" @query-change="onChangeTable">
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom" :width="title.prop.width">
          </el-table-column>
          <el-table-column label="Type" align="left" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1" class="px-2 py-1 text-xs font-bold text-white bg-yellow-600 rounded">Premium</span>
              <span v-else class="px-2 py-1 text-xs font-bold text-white bg-gray-500 rounded">Free</span>
            </template>
          </el-table-column>
          <el-table-column v-if="isAdmin || isSuperAdmin" label="Actions" align="right" width="180px" fixed="right">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip v-if="scope.row.type == 0" label="Set Premium" :position="'is-left'">
                  <button @click="setPremium(scope.row)" class="p-2 w-8 mr-2 rounded bg-yellow-600 hover:bg-yellow-700 focus:outline-none">
                    <font-awesome-icon class="text-white" :icon="['fa', 'crown']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-else label="Revert to Free" :position="'is-left'">
                  <button @click="revertPremium(scope.row)" class="p-2 w-8 mr-2 rounded bg-red-600 hover:bg-red-700 focus:outline-none">
                    <font-awesome-icon class="text-white" :icon="['fa', 'undo']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
  </div>
</template>
<script>
import { Button } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      isLoading: false,
      displayingItem: 20,
      data: [],
      total: 0,
      page: 1,
      grantDuration: '1_month',
      durationOptions: [
        { value: '1_month', label: '1 Month' },
        { value: '1_year', label: '1 Year' },
        { value: 'permanent', label: 'Permanent' },
      ],
      filter: {
        per_page: 20,
        page: 1,
        q: '',
      },
      titles: [{
        prop: {
          field: 'name',
          width: '250',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'email',
          width: '250',
        },
        label: 'Email',
      }, {
        prop: {
          field: 'country_name',
          width: '135',
        },
        label: 'Country',
      }, {
        prop: {
          field: 'created_at',
          width: '140',
        },
        label: 'Created At',
      }],
    };
  },
  async mounted() {
    await this.requestListUserApp(this.filter);
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin']),
    ...mapGetters('UserModule', ['listUserApp']),
  },
  watch: {
    listUserApp: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
  },
  methods: {
    ...mapActions('UserModule', ['requestListUserApp', 'requestSetUserPremium']),
    async searchUser() {
      await this.requestListUserApp(this.filter);
      this.refineData();
    },
    async reset() {
      this.$refs.tableUser.$refs.elTable.clearSort();
      this.filter = { per_page: 20, page: 1, q: '' };
      this.searchUser();
    },
    refineData() {
      if (this.listUserApp.data !== undefined) {
        this.total = this.listUserApp.data.total;
        this.data = this.listUserApp.data.data.map((user, index) => Object.assign({}, user, {
          created_at: moment(user.created_at).format('YYYY-MM-DD HH:mm:ss'),
          seq: ((this.page - 1) * this.displayingItem) + index + 1,
        }));
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      this.page = page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = { ...this.filter, per_page: this.displayingItem, sortorder, sortby, page };
      await this.requestListUserApp(this.filter);
    },
    setPremium(row) {
      Vue.swal({
        title: 'Set Premium!',
        text: `Are you sure to set user ${row.name} to premium?`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = { id: row.id, is_premium: 1, duration: this.grantDuration };
          await this.requestSetUserPremium({ data, filter: this.filter });
          this.$swal('Success', `You successfully set user ${row.name} to premium`, 'success');
        }
      });
    },
    revertPremium(row) {
      Vue.swal({
        title: 'Revert to Free!',
        text: `Are you sure to revert user ${row.name} to free?`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = { id: row.id, is_premium: 0 };
          await this.requestSetUserPremium({ data, filter: this.filter });
          this.$swal('Success', `You successfully revert user ${row.name} to free`, 'success');
        }
      });
    },
  },
  components: {
    Card,
    Button,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/UsersPremium.vue